import colors from '@theme/colors';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: colors.overlay.backdrop,
    justifyContent: 'flex-end',
  },
  containerStyle: { margin: 0 },
  heightCommon: {
    // maxHeight: '80%',
    // minHeight: '50%',
  },
  modalContainer: {
    backgroundColor: colors.overlay.backdrop,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
  },
  modalParent: containerStyle => ({
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    //  margin: 10,
    ...containerStyle,
  }),
});

export default styles;
